export default function getRefs() {
  return {
   
    galleryRef: document.querySelector('.caterories-content'),

    categoriesRef: document.querySelector('.nav-categories-list'),
  

  };
}